import React from 'react'
import { ListItemIcon, ListItemText, Menu, MenuItem, PopoverPosition } from '@mui/material'
import { ContextualMenuItem } from 'ts/types/commonTable.types'
import AgNestedMenuItem from './AgNestedMenuItem'
import './styles.scss'

export interface AgContextMenuProps {
  items: ContextualMenuItem[]
  onClose: () => void
  anchorEl?: HTMLElement | null
  anchorPosition?: PopoverPosition
  maxHeight?: number
  className?: string
}

const AgContextMenu: React.FunctionComponent<AgContextMenuProps> = (props: AgContextMenuProps) => {
  const { items, onClose, anchorEl, anchorPosition, maxHeight, className } = props
  const isMenuOpen = !!anchorEl || !!anchorPosition

  const renderItem = (
    item: ContextualMenuItem,
    index: number,
    parentIndexes?: number[],
    parentDisabled?: boolean
  ) => {
    const key = `${parentIndexes ? parentIndexes.join('-') : '0'}-${index || '0'}`

    if (item.items) {
      return (
        <AgNestedMenuItem
          leftIcon={item.icon}
          label={item.content}
          parentMenuOpen={isMenuOpen}
          onClick={item.disabled ? undefined : item.onClick}
          disabled={item.disabled}
          key={`${key}-nested`}
        >
          {item.items.map((subItem: ContextualMenuItem, subIndex: number) =>
            renderItem(subItem, subIndex, [...(parentIndexes || []), index], item.disabled)
          )}
        </AgNestedMenuItem>
      )
    }

    return item.noWrap ? (
      <div key={key}>{item.content}</div>
    ) : (
      <MenuItem
        onClick={item.disabled || parentDisabled ? undefined : item.onClick}
        disabled={item.disabled || parentDisabled}
        key={key}
      >
        {item.icon ? (
          <ListItemIcon className="list-item-icon">
            {typeof item.icon === 'string' ? (
              <img src={item.icon} alt={item.content as string} />
            ) : (
              <item.icon title={item.content as string} />
            )}
          </ListItemIcon>
        ) : null}
        <ListItemText primary={item.content} />
      </MenuItem>
    )
  }

  return (
    <Menu
      open={isMenuOpen}
      anchorReference={anchorEl ? 'anchorEl' : 'anchorPosition'}
      anchorEl={anchorEl}
      anchorPosition={anchorPosition}
      onClose={onClose}
      slotProps={{
        paper: maxHeight
          ? {
              style: {
                maxHeight,
              },
            }
          : undefined,
      }}
      className={className}
      onContextMenu={(event: any) => {
        event.preventDefault()
        event.stopPropagation()
        if (event.target && !(event.target as HTMLElement).closest('.MuiPopover-paper')) {
          onClose()
        }
      }}
    >
      {items.map((item, index) => renderItem(item, index))}
    </Menu>
  )
}

export default AgContextMenu
